export default {
  'TITLE_TAB': 'Descargas',
  'TITLE': 'Descargas',
  'SELECT_PROFILES': 'Selecciona la base de datos de usuarios registrados',
  'DOWNLOAD_BUTTON': 'Descargar',
  'PLACEMENT_PLACEHOLDER': 'Sitio',
  'DOWNLOAD_USER_SUCCESS_MESSAGE': 'Descarga exitosa',
  'PROFILES_TOOLTIP_TEXT': 'por 12 meses',
}
